<template>
<div class="chapter">
<div class="inner_page">
<div class="image-wrap">
<div class="image">
<img alt="image" class="calibre1" src="images/00006.jpeg"/>
</div>
</div>
<p class="paracenter1">A. L. F. S<span class="small">CHAUMANN</span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0009.vue?84ce2dd6